import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withFirestore } from 'react-redux-firebase';
import {
  submitDealProposal,
  createNewProposal
} from '../../../store/actions/dealActions';

const styles = theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 10,
    [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
      width: '100%',
      maxWidth: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  root: {
    width: '100%',
    padding: '30px'
  },
  pageTitle: {
    marginBottom: '20px',
    cursor: 'pointer'
  },
  backButton: {
    marginBottom: '4px',
    marginRight: '10px'
  },
  offerTerms: {
    maxWidth: '300px'
  },
  userPic: {
    width: '100%',
    height: '100%',
    maxHeight: '200px',
    maxWidth: '200px'
  },
  radioGroup: {
    // paddingLeft: '75px'
  },
  details: {
    // minHeight: '150px',
    width: '100%'
  },
  submitButton: {
    float: 'right',
    color: '#ffffff'
  },
  userPanel: {
    width: '350px'
  },
  deal: {
    width: 200,
    textAlign: 'center',
    margin: '10px 0'
  },
  termsText: {
    height: '75px'
  },
  submitAcceptButtons: {
    float: 'right',
    color: 'white'
  }
});

const mapStateToProps = state => {
  return {
    profile: state.firebase.profile,
    user: state.firebase.auth
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    submitDealProposalHandler: (dealId, updaterId, prosposalInfo) =>
      dispatch(submitDealProposal(dealId, updaterId, prosposalInfo, ownProps)),
    createNewProposalHandler: (
      influencerId,
      companyId,
      prosposalInfo,
      campaignId,
      isCompany,
      updaterId,
      onComplete
    ) =>
      dispatch(
        createNewProposal(
          influencerId,
          companyId,
          prosposalInfo,
          campaignId,
          isCompany,
          updaterId
        )
      )
        .then(() => {
          onComplete();
        })
        .then(() => {
          onComplete();
        })
  };
};

export default compose(
  withStyles(styles),
  withRouter,
  withFirestore,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withProps(({ profile, auth }) => ({
    profile,
    auth
  }))
);



// WEBPACK FOOTER //
// ./src/components/deals/new-deal/DealForm.enhancer.js